import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { breakpoints } from 'globalStyles'

const Branding = styled.h1`
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  @media only screen and ${breakpoints.desktop} {
    font-size: 26px;
    line-height: 38px;
  }
`

export default () => {
  const { t } = useTranslation()

  return <Branding>{t('landing_page.welcome')}</Branding>
}
